import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import { Calendar, Share2, MessageCircle, CalendarCheck, ArrowLeft } from "lucide-react";
import { GoldButton, PrimaryButton } from "@/components/Ui";
import { CONFIG } from "@/data/content";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmtDate = (d) => new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" });

const NewsDetail = () => {
  const { id } = useParams();
  const [n, setN] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`${API}/news/${id}`).then((r) => setN(r.data)).catch((err) => { console.error("Errore caricamento articolo:", err); setNotFound(true); });
  }, [id]);

  const share = async () => {
    const url = window.location.href;
    if (navigator.share) {
      try { await navigator.share({ title: n.titolo, url }); } catch (err) { console.error("Condivisione annullata:", err); }
    } else {
      await navigator.clipboard.writeText(url);
      toast.success("Link copiato negli appunti");
    }
  };

  if (notFound) return <div className="max-w-3xl mx-auto px-5 py-32 text-center"><h1 className="font-serif text-3xl text-navy-900">Articolo non trovato</h1><div className="mt-6"><PrimaryButton to="/news">Torna alle news</PrimaryButton></div></div>;
  if (!n) return <div className="py-32 text-center text-slate-500">Caricamento…</div>;

  const waShare = `https://wa.me/?text=${encodeURIComponent(n.titolo + " " + window.location.href)}`;

  return (
    <article data-testid="news-detail-page">
      <div className="bg-navy-900 relative overflow-hidden">
        <div className="absolute inset-0"><img src={n.immagine} alt={n.titolo} className="w-full h-full object-cover opacity-25" /><div className="absolute inset-0 bg-navy-900/70" /></div>
        <div className="relative max-w-4xl mx-auto px-5 lg:px-8 py-20 md:py-28">
          <Link to="/news" className="inline-flex items-center gap-2 text-white/70 hover:text-gold-400 text-sm font-semibold mb-6 transition-colors"><ArrowLeft className="w-4 h-4" /> Tutte le news</Link>
          <div className="flex items-center gap-3 text-xs">
            <span className="bg-gold-500 text-navy-900 font-bold uppercase tracking-[0.1em] px-2.5 py-1">{n.categoria}</span>
            <span className="flex items-center gap-1 text-white/70"><Calendar className="w-3.5 h-3.5" />{fmtDate(n.data)}</span>
          </div>
          <h1 className="mt-5 font-serif text-4xl md:text-5xl font-semibold text-white leading-tight">{n.titolo}</h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-5 lg:px-8 py-16">
        <p className="text-xl font-serif text-navy-900 leading-relaxed">{n.estratto}</p>
        <p className="mt-6 text-slate-600 leading-relaxed text-lg">{n.testo}</p>

        <div className="mt-10 flex flex-wrap gap-3">
          <button onClick={share} data-testid="news-share-btn" className="inline-flex items-center gap-2 border border-gray-200 hover:border-gold-500 px-5 py-3 text-sm font-bold uppercase tracking-[0.1em] text-navy-900 transition-colors"><Share2 className="w-4 h-4" /> Condividi</button>
          <a href={waShare} target="_blank" rel="noreferrer" data-testid="news-whatsapp-btn" className="inline-flex items-center gap-2 bg-[#25D366] text-white px-5 py-3 text-sm font-bold uppercase tracking-[0.1em] hover:bg-[#20bd5a] transition-colors"><MessageCircle className="w-4 h-4" /> WhatsApp</a>
          <GoldButton to="/prenota"><CalendarCheck className="w-4 h-4" /> Prenota una consulenza</GoldButton>
        </div>
      </div>
    </article>
  );
};

export default NewsDetail;
